export const defaultTag = (tag = null) => ({
    isFetching: false,
    error: null,
    tag,
});

// { [assetId]: defaultAsset }
export const defaultState = {};
